import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Plus, Wand2 } from "lucide-react";

const STATUS_LABEL = {
  drafting_need: "Documento di Bisogno",
  awaiting_confirmation: "In attesa di conferma",
  building: "In costruzione",
  preview_ready: "Anteprima pronta",
  delivered: "Consegnata",
  failed: "Errore",
};
const STATUS_COLOR = {
  drafting_need: "rgba(85,85,85,0.1)",
  awaiting_confirmation: "rgba(234,179,8,0.15)",
  building: "rgba(15,61,107,0.1)",
  preview_ready: "rgba(34,197,94,0.12)",
  delivered: "rgba(34,197,94,0.18)",
  failed: "rgba(200,16,46,0.1)",
};
const STATUS_TEXT_COLOR = {
  preview_ready: "#15803d", delivered: "#15803d", failed: "#C8102E", building: "#0F3D6B",
};

export default function CostruisciList() {
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/custom-apps").then((r) => setApps(r.data.items || [])).finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <div className="flex items-center justify-between mb-8 flex-wrap gap-3">
        <div>
          <div className="adr-overline mb-2">Le mie applicazioni</div>
          <h1 className="serif text-3xl sm:text-4xl font-semibold tracking-tight text-[#1A1A1A]">App custom</h1>
        </div>
        <Link to="/costruisci" className="adr-btn-primary text-sm" data-testid="new-custom-app">
          <Plus className="w-4 h-4 inline mr-1.5" /> Nuova applicazione
        </Link>
      </div>

      {loading ? (
        <div className="space-y-3">{Array.from({ length: 3 }).map((_, i) => <div key={i} className="adr-skeleton h-20" />)}</div>
      ) : apps.length === 0 ? (
        <div className="adr-card p-12 text-center">
          <Wand2 className="w-12 h-12 mx-auto mb-3 text-[#0F3D6B]/40" />
          <h3 className="serif text-xl font-semibold mb-1.5">Nessuna applicazione ancora</h3>
          <p className="text-sm text-[#555555] mb-6">Inizia descrivendo l'applicazione di cui hai bisogno.</p>
          <Link to="/costruisci" className="adr-btn-primary">Inizia</Link>
        </div>
      ) : (
        <div className="space-y-3">
          {apps.map((a) => (
            <Link key={a.id} to={`/costruisci/${a.id}`} className="adr-card p-5 block" data-testid={`custom-app-row-${a.id}`}>
              <div className="flex items-center justify-between gap-4">
                <div className="min-w-0 flex-1">
                  <div className="serif text-lg font-semibold text-[#1A1A1A] truncate mb-1">{a.title}</div>
                  <div className="text-xs text-[#555555]">{new Date(a.created_at).toLocaleString("it-IT")} · v{a.current_version || 0}</div>
                </div>
                <span className="adr-badge" style={{ background: STATUS_COLOR[a.status] || "rgba(85,85,85,0.1)", color: STATUS_TEXT_COLOR[a.status] || "#555555" }}>
                  {STATUS_LABEL[a.status] || a.status}
                </span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
